import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    useInitNewAuthenticatorQuery,
    useVerifyAuthenticatorFromSettingsMutation
} from '../../../../slices/account-api.slice';
import { LoadingDots, TertiaryButton, Flex } from '@workday/canvas-kit-react';
import { AuthenticatorQrCode } from '../../../../shared/authenticator-qr-code/authenticator-qr-code';
import { useTranslation } from 'react-i18next';

export function RegisterAuthenticatorEntry({ onCloseModal }) {
    const dispatch = useDispatch();

    const { data: authenticator, isLoading } = useInitNewAuthenticatorQuery();

    const [verifyAuthenticatorFromSettings, verifyAuthenticatorFromSettingsMutation] =
        useVerifyAuthenticatorFromSettingsMutation();

    const { t } = useTranslation('account');

    useEffect(() => {
        if (verifyAuthenticatorFromSettingsMutation.isSuccess) {
            onCloseModal();
        }
    }, [dispatch, verifyAuthenticatorFromSettingsMutation.isSuccess, onCloseModal]);

    function onSubmit(payload) {
        verifyAuthenticatorFromSettings(payload);
    }

    return isLoading ? (
        <LoadingDots />
    ) : (
        <Flex flexDirection='column' paddingTop='1rem'>
            {authenticator && (
                <AuthenticatorQrCode
                    title={t('Authenticator.title')}
                    mutation={verifyAuthenticatorFromSettingsMutation}
                    authenticator={authenticator}
                    onSubmit={onSubmit}
                />
            )}
            <TertiaryButton type='button' size='large' onClick={onCloseModal} marginTop='1rem'>
                {t('Common.cancel', { ns: 'shared' })}
            </TertiaryButton>
        </Flex>
    );
}
